import React, { useEffect, useMemo, useState } from "react";
import {
	Divider,
	Grid,
} from "@material-ui/core";
import useStyle from "./ForgotPassword.styles";
import logo_login from "../../assets/images/logo-login.svg";
import InputField from "../../components/InputField/InputField";
import {
	Lock,
	Mail,
} from "@material-ui/icons";
import { useHistory } from "react-router-dom";
import Footer from "../../components/Footer/Footer";
import Slider from "react-slick";
import StyledButton from "../../components/StyledButton/StyledButton";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import ReCAPTCHA from "react-google-recaptcha";
import { generalReducerActions } from "../../store/reducers/generalReducer";
import { checkVerificationCode, sendResetPasswordRequest } from "../../store/reducers/authReducer";
import slide1 from "../../assets/images/Login_Page/slide1.png";
import slide2 from "../../assets/images/Login_Page/slide2.png";
import slide3 from "../../assets/images/Login_Page/slide3.png";
import { useFormik } from 'formik';
import { getForgotPasswordValidation } from "./validation";
import classNames from "classnames";

const bg = [slide1, slide2, slide3]

const ForgotPassword = (props) => {
	const dispatch = useDispatch();
	const styles = useStyle();
	const { t, i18n } = useTranslation();
	const history = useHistory();
	const [captchaChecked, setCaptchaChecked] = useState(false);
	const [index, setIndex] = useState(0);

	const sliderText = useMemo(() => ['Attracting young talents, to develop and maintain their abilities', 'Discovering the talents and competencies of human cadres in the specialized and technical fields', 'Our vision is an emirate with integrated sustainable urban development and outstanding municipal services for the well-being and happiness of the community'], [])

	const onChangeRecaptcha = (value) => {
		if (value) {
			setCaptchaChecked(true)
		}
	}

	const onExpiredRecaptcha = () => {
		setCaptchaChecked(false)
	}

	const onEmailSubmitHandler = async () => {
		if (!captchaChecked) {
			dispatch(generalReducerActions.snackBarUpdate({
				open: true,
				message: `Invalid Captcha`,
				severity: 'warning',
			}));
		} else {
			let data = { Email: formik.values.email }
			dispatch(generalReducerActions.toggleLoading(true))
			const response = await dispatch(sendResetPasswordRequest(data));
			window.grecaptcha.reset();
			if (response.payload.status === 200) {
				dispatch(generalReducerActions.toggleLoading(false));
				dispatch(generalReducerActions.snackBarUpdate({
					open: true,
					message: "Password recovery email sent. If the email you entered exists in our record, you will receive a verification code in your email to recover your password",
					severity: 'success',
				}));
				formik.setValues({ ...formik.values, showVerifyCode: true });
				formik.setTouched({ ...formik.touched, verificationCode: false });
				setCaptchaChecked(false);
			} else {
				dispatch(generalReducerActions.toggleLoading(false));
				dispatch(generalReducerActions.snackBarUpdate({
					open: true,
					message: response.payload.data.Message || "Something went wrong. We are having trouble completing your request, please try again",
					severity: 'error',
				}));
				setCaptchaChecked(false);
			}
		}
	}

	const onVerificationCodeSubmitHandler = async () => {
		if (!captchaChecked) {
			dispatch(generalReducerActions.snackBarUpdate({
				open: true,
				message: `Invalid Captcha`,
				severity: 'warning',
			}));
		} else {
			dispatch(generalReducerActions.toggleLoading(true))
			const response = await dispatch(checkVerificationCode(formik.values.verificationCode));
			if (response.payload.status === 200) {
				dispatch(generalReducerActions.toggleLoading(false));
				formik.setValues({ ...formik.values, showVerifyCode: false });
				setCaptchaChecked(false);
				history.replace({ pathname: "/reset-password", state: { resetPassword: true, RegistrationId: response.payload.data.RegistrationId } });
			} else {
				dispatch(generalReducerActions.toggleLoading(false));
				dispatch(generalReducerActions.snackBarUpdate({
					open: true,
					message: "Invalid verfication code",
					severity: 'error',
				}));
			}
		}
	};

	const formik = useFormik({
		initialValues: {
			email: "",
			verificationCode: "",
			showVerifyCode: false,
		},
		validationSchema: getForgotPasswordValidation(t),
		onSubmit: () => {
			formik.values.showVerifyCode ? onVerificationCodeSubmitHandler() : onEmailSubmitHandler()
		},
	});

	useEffect(() => {
		document.title = `${t('Forgot Password')} - ${t("DMT Career Portal")}`
	}, [i18n.language, t])

	return (
		<Grid container direction="row">
			<Grid item className={`${styles.loginFormGrid} login-form-wrapper`}>
				<div className={styles.loginLogo}>
					<img src={logo_login} className={styles.logo} alt="logo" />
				</div>
				<form style={{ width: "75%" }} onSubmit={formik.handleSubmit} >
					{
						formik.values.showVerifyCode ? (
							<InputField
								containerClass={styles.inputFields}
								className={classNames({ [styles.error]: formik.touched.verificationCode && Boolean(formik.errors.verificationCode) })}
								label={t("Verification Code")}
								name="verificationCode"
								value={formik.values.verificationCode}
								onChange={formik.handleChange}
								helperText={formik.touched.verificationCode && formik.errors.verificationCode}
								startAdornment={<Lock classes={{ root: styles.icon }} />}
								endAdornment=""
							/>
						) : (
							<InputField
								containerClass={styles.inputField}
								className={classNames({ [styles.error]: formik.touched.email && Boolean(formik.errors.email) })}
								label={t("Email")}
								name="email"
								value={formik.values.email}
								onChange={formik.handleChange}
								helperText={formik.touched.email && formik.errors.email}
								startAdornment={<Mail classes={{ root: styles.icon }} />}
								endAdornment=""
							/>
						)
					}
					<Grid className={styles.reCaptchaGrid} container direction="row" justifyContent="center" alignItems="center" >
						<ReCAPTCHA
							hl={i18n.language}
							// sitekey="6Ld08YQaAAAAAKMjEaZ9u4WMXYfywPVmmjmQUuPM"   //old key
                //sitekey="6LcM98cUAAAAAPvIMa6wiMfDySx9Hj2TDAF77H-K"      //staging site key
                sitekey="6LdbctUfAAAAAADBTvbWN6i1_FKaA2owkOmz5qa7"    //production site key
							onChange={onChangeRecaptcha}
							onExpired={onExpiredRecaptcha}
						/>
					</Grid>
					<Grid
						container
						direction="row"
						justifyContent="space-between"
						alignItems="center"
						className={styles.actionGrid}
					>
						<StyledButton className={styles.submitButton} type="submit">
							{t("Submit")}
						</StyledButton>
					</Grid>
				</form>
				<Footer className={styles.footer} />
			</Grid>
			<Grid item className={styles.backgroundGrid} style={{ backgroundImage: `url(${bg[index]})` }}>
				<p className={styles.welcomeText}>{t("Welcome to")}</p>
				<p className={styles.infoText}>{t("DMT CAREER PORTAL")}</p>
				<Divider className={styles.divider} />
				<Slider
					arrows={false}
					dots={true}
					speed={500}
					autoplay={true}
					autoplaySpeed={5000}
					dotsClass={styles.sliderDots}
					afterChange={(slide) => setIndex(slide)}
				>
					{sliderText.map((txt, index) => (
						<div key={index}>
							<h4>{t(txt)}</h4>
						</div>
					))}
				</Slider>
			</Grid>
			<Footer className="slider-footer" />
		</Grid>
	);
};

export default ForgotPassword;
